import { cn } from '@/app/lib/utils';
import { ScrollTrackProps } from '../scrollbar.types';

export function ScrollTrack({ orientation, className, children, trackRef, autoHide = false }: ScrollTrackProps) {
  const trackBase = autoHide ? 'opacity-60 hover:opacity-100 transition-opacity duration-150' : 'opacity-100';

  const baseClasses =
    orientation === 'vertical'
      ? 'pointer-events-none  absolute right-0 z-20'
      : 'pointer-events-none  absolute -bottom-lg left-0 right-0 z-20';

  return (
    <div ref={trackRef} className={cn(baseClasses, trackBase, className)} aria-hidden>
      {children}
    </div>
  );
}
